<template>
    <NotificationMarker
        v-if="alarm != null && alarm.latitude != null"
        :alarm="alarm"
        :latitude="alarm.latitude"
        :longitude="alarm.longitude"
    />
</template>

<script>
import NotificationMarker from './NotificationMarker.vue'

export default {
    props: ['alarm'],
    components: {
        NotificationMarker
    }
}
</script>